import React from 'react';
import ProfessionalsEmployeeDetails from '../../../components/professionals/ProfessionalsEmployeeDetails';
import '../../../components/professionals/ProfessionalsEmployeeDetails.scss';
import { useAgencyProfessionalQuery } from '../../../redux/external-agency';

const AgencyProfessionalsEmployeeDetails = ({ caregiverId, onEdit }) => {
	const { data: professional, isFetching } = useAgencyProfessionalQuery(caregiverId, {
		refetchOnMountOrArgChange: true
	});

	return <ProfessionalsEmployeeDetails professional={professional} isFetching={isFetching} onEdit={onEdit} />;
};

export default AgencyProfessionalsEmployeeDetails;
